// Page components
// These are containers for Block components
//import Page from './page'

// site navigation menu
// navigation menu components
import NavItemLogo from './navigation/NavItemLogo'
import NavItemLink from './navigation/NavItemLink'
import NavItemLogin from './navigation/NavItemLogin'
import NavItemLanguageSelect from './navigation/NavItemLanguageSelect'
import NavItemSocialIcons from './navigation/NavItemSocialIcons'

// site content
// section content components
import ContentHeadline from './content/content-headline'
import ContentButton from './content/content-button'
import ContentAccordionImage from './content/content-accordion-image'
import ContentGrid from './content/content-grid'
import ContentSlider from './content/content-slider'
import ContentText from './content/content-basic-text'
import ContentStatistics from './content/content-statistic'
import ContentCard from './content/content-card'
import ContentCardGrid from './content/content-card-grid'
import ContentTimeline from './content/content-timeline'
import ContentAnimatedScroller from './content/content-scrolling'
import ContentBasicImage from './content/content-basic-image'
import ContentInstagramFeed from './content/content-instagram-feed'
import ContentList from './content/content-list'
import ContentDivider from './content/content-divider'
import ContentCardHorizontal from './content/content-card-horizontal'
import ContentCustomScript from './content/content-custom-script'

// This is where we process the Component Type from Storyblok to determine what template to use to load the Block Components into
const components = {
  NavItemLogo,
  NavItemLink,
  NavItemLogin,
  NavItemLanguageSelect,
  NavItemSocialIcons,
  ContentHeadline,
  ContentButton,
  ContentText,
  ContentAccordionImage,
  ContentGrid,
  ContentSlider,
  ContentCard,
  ContentCardGrid,
  ContentStatistics,
  ContentTimeline,
  ContentAnimatedScroller,
  ContentInstagramFeed,
  ContentBasicImage,
  ContentList,
  ContentDivider,
  ContentCardHorizontal,
  ContentCustomScript,
}

export default components